import { Result, Button } from "antd";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Trang Sếp tìm không tồn tại."
      extra={
        <Link to="/">
          <Button type="primary">Về trang chủ</Button>
        </Link>
      }
    />
  );
}

export default NotFound;
